import MarkdownIt from "markdown-it";
const md = new MarkdownIt({
  html: false,
  linkify: true,
  breaks: true,
  typographer: false,
});
// Journal rendering never fetches third-party images or permits executable HTML.
md.renderer.rules.image = (tokens, i) =>
  `<span class="image-reference">[Image: ${md.utils.escapeHtml(tokens[i].content)}]</span>`;
const link =
  md.renderer.rules.link_open ||
  ((tokens, i, options, env, self) => self.renderToken(tokens, i, options));
md.renderer.rules.link_open = (tokens, i, options, env, self) => {
  tokens[i].attrSet("rel", "noreferrer noopener");
  tokens[i].attrSet("target", "_blank");
  return link(tokens, i, options, env, self);
};
export const renderMarkdown = (source = "") => md.render(source);
